// -----------------------------------------------
// BECAUSE IE IS CACHING updateCartTotals CALL
// -----------------------------------------------

import { hideCartModal, showCartHoverPreview } from "../utils/utils"

$.ajaxSetup({ cache: false })

// -----------------------------------------------
// SET REUSABLE VARIABLES
// -----------------------------------------------

const MONEY_FORMAT = '$ {{amount}}'

// -----------------------------------------------
// SET UP QUEUE FOR AJAX CALLS
// -----------------------------------------------

const Queue = () => {
	var previous = new $.Deferred().resolve()

	return (fn, fail) => {
		return previous = previous.then(fn, fail || fn)
	}
}
const queue = Queue()

/**
 * Updates the cart totals in the header and cart page
 *
 * @param {function} callback - A callback function to run after the cart totals have been updated
 */

const updateCartTotals = (callback) => {
	queue(() => {
		// Get the cart
		$.get('/cart.js', () => {}, 'json')
			// When we get the cart, update the cart totals
			.done(cart => {
				cart.item_count < 99 ? $('.nav-cart-count').text(cart.item_count) : $('.nav-cart-count').text('99+')
				cart.item_count < 2 ? $('.cart-items-pluralize').text('Item') : $('.cart-items-pluralize').text('Items')
				$('.cart-items-count').text(cart.item_count)
				$('.items-subtotal-price').html(Shopify.formatMoney(cart.total_price, MONEY_FORMAT))
				$('.cart-total').html(Shopify.formatMoney(cart.total_price, MONEY_FORMAT))

				// If we have a callback, call it with the cart
				if (callback) callback(cart)
			})
			.fail((response) => {
				// If we fail, log an error
				console.error("Failed to update cart totals: ", response)
			})
	})
}

/**
 *
 * Updates the quantity of a specific line item in the shopping cart
 *
 * @param {number} lineItemKey - The key of the line item to update
 * @param {number} lineItemQuantity - The new quantity of the line item
 */

const updateCartLineItem = (lineItemKey, lineItemQuantity) => {
	queue(() => {
		$.post(
			'/cart/change.js',
			{
				id: lineItemKey,
				quantity: lineItemQuantity,
			},
			(data) => {
				// Success callback: This function is called when the post request succeeds.
				// It updates the line item price and discounts, and then updates the cart totals.
				const cart = data // Assuming the response is the cart data

				const $lineItems = $('.cart-item-item')

				// Update line item price and discounts
				$.each(cart.items, (i, lineItem) => {
					const $lineItem = $($lineItems[i])
					const $lineItemSinglePrice = $lineItem.find('.item-single-price')
					const $lineItemPrice = $lineItem.find('.item-line-price')

					// Update the line item price with the new value from the cart data
					$lineItemPrice.text(Shopify.formatMoney(lineItem.final_line_price, MONEY_FORMAT))

					// Show/hide the single item price based on the quantity
					lineItem.quantity <= 1 ? $lineItemSinglePrice.addClass('hide') : $lineItemSinglePrice.removeClass('hide')

					if (lineItem.discounts.length || lineItem.line_level_discount_allocations.length) {
						const discountMessage = lineItem.discounts
							.map(function (discount) { return discount.title })
							.join(', ')

						// Show the discount message if there are discounts
						const $discountSpan = $('<span>', { text: ' ' + discountMessage + ' ' })
						$lineItem.find('.item-message').empty().append($discountSpan).show()
						$lineItemPrice.addClass('discount')

					} else {
						// Hide the discount message and remove the 'discount' class from the line item price
						$lineItem.find('.item-message').empty().hide()
					}
				})

				// Update the cart totals
				updateCartTotals()
			},
			'json'
		)
		.fail(function (response) {
			// Error callback: This function is called when the post request fails.

			console.error('Failed to update: ', response)
			alert('The quantity that you entered is not available. Please select a lower quantity to continue')
		})
	})
}


/**
 * Updates the quantity of a specific line item in the shopping cart
 *
 * @param {number} variantID - The ID of the variant to update
 * @param {number} quantity - The new quantity of the line item
 *
 */
const updateCartLineItemVariant = (productID, quantity, properties) => {
    queue(() => {
        // Send a POST request to the Shopify AJAX API to update the cart line item variant
        $.post('/cart/add.js',
            {
                id: productID,  // ID of the variant to update
                quantity: quantity,  // new quantity of the line item
				properties: properties, // new properties of the line item
            },
			data => {}, // Success callback: This function is called when the post request succeeds.
            'json', // data should be sent as JSON
        )
        .done(() => {
            // Successful AJAX request, update the cart totals
            updateCartTotals()
			// refresh page
			window.location.reload()
        })
        .fail(response => {
            // Failed AJAX request, log the error, message the user, and re-enable the inputs
            console.error("Failed to update: ", response )
            alert('The option you selected is not available, please pick a different option.')
        })
    })
}

/**
 * Removes a specific line item from the shopping cart
 *
 * @param {number} index - The index of the line item to remove
 */

const removeCartLineItem = (index) => {
	queue(() => {
		// Return the result of the AJAX request
		return (
			// Send a POST request to the Shopify AJAX API to change the cart
			$.post('/cart/change.js',
				{
					// Set the quantity of the line item to 0, removing it from the cart
					quantity: 0,
					// Specify the line item to change using its index
					line: index
				},
				// Empty success callback, as no action is taken with the returned data from the AJAX request
				() => {},
				'json' // data should be sent as JSON
			)
			// Empty .done() callback, no action is taken upon successful request
			.done(cart => {})
		)
	})
}

/**
 * Adds a product to the shopping cart.
 *
 * @param {jQuery} $btn - The add-to-cart button
 * @param {function} callback - A callback function to execute after the product is added
 */

const addToCart = ($btn, callback) => {
    // Hide the add-to-cart button and quantity field, and show a spinner
    $btn.hide()
    $('#QtyArea').toggleClass('QtyAreaVisibilityToggle') // Preserve inline-block by using toggleClass instead of hide
    $('<div class="spinner-add-to-cart sk-spinner sk-spinner-pulse"></div>').insertAfter($btn)

    // Create a FormData object from the add-to-cart form
    const formData = new FormData($('#AddToCartForm')[0])

    // Add the product to the cart
    queue(() => {
        $.post({
            url: '/cart/add.js',
            contentType: false,
            processData: false,
            data: formData,
            dataType: 'json'
        })
        .done(() => {
            // If the request is successful, remove any existing checkout callouts and success messages
            $('.checkout-callout').remove()
            $('.added-success-message').remove()

            // Remove the spinner
            // $('.spinner-add-to-cart').remove()

            // Show a success message
            // if ($('.added-success-message').length < 1) {
            //     var $added_success = $("<p class='added-success-message'>Item successfully added to cart.</p>")
            //     $added_success.insertAfter($btn)
            // }

            // Show a checkout callout
            if ($('.checkout-callout').length < 1) {
                var $checkout_callout = $("<div class='checkout-callout'></div>")
                $checkout_callout.append("<p>Cart <span class='cart-items-count'></span> Items | <span class='cart-total'></span></p>")
                $checkout_callout.append("<a class='btn' href='/cart'>Checkout</a>")
                $checkout_callout.hide().insertAfter('#PriceQtyAdd')
            }

            // Update the cart totals
            updateCartTotals(() => {
                $checkout_callout.show()
            })

			initCartSelectWidth()

            // Execute the callback function
            if (callback) callback()

            // After 3 seconds, clear the success message and show the add-to-cart button and quantity field again
            setTimeout(() => {
                $added_success.fadeOut(400, () => {
                    $btn.fadeIn()
                    $('#QtyArea').fadeIn()
                    $('#QtyArea').toggleClass('QtyAreaVisibilityToggle')
                    $(this).closest('form').find("input[type=text], textarea").val("")
                    $(this).remove()
                })
            }, 3000)
        })
        .fail(() => {
            // If the request fails, show an alert to the user, remove the spinner, and show the add-to-cart button and quantity field again
			alert('The quantity that you entered is not available. Please select a lower quantity to continue')
            $('.spinner-add-to-cart').remove()
            $btn.show()
            $('#QtyArea').toggleClass('QtyAreaVisibilityToggle') // Preserve inline-block by using toggleClass instead of hide.
        })
    })
}

/**
 * Adds a product to the shopping cart.
 *
 * @param {jQuery Object} $btn - The button object that triggers this function.
 * @param {number} product_id - The ID of the product to add to the cart.
 * @param {number} quantity - The quantity of the product to add.
 * @param {Object} properties - Additional properties related to the product.
 *
 */

$(document).ready(function() {

	// -----------------------------------------------
	// BREED CHOOSER
	// -----------------------------------------------

	if (!Modernizr.touchevents && !Modernizr.pointerevents) {
		$('.breed-chooser').each(function(i, element) {
			$(element).find('select').on('chosen:ready', function() {
				$(element).find('.chosen-single').append("<i class='chevron down'></i>")

				setTimeout(function() {
					$(element).fadeIn('slow')
				}, 500)

			})
		})

		$('.breed-chooser select').each(function(element) {
			$(element).chosen()
		})

		$('.breed-chooser select').each(function(element) {
			$(element).chosen().change(function() {
				window.location.href = $(this).val()
			})
		})

		if ($('.chosen-container').length > 0) {
			$('.chosen-container').on('touchstart', function(e) {
				e.stopPropagation()
				e.preventDefault()
				$(this).trigger('mousedown')
			})
		}
	}
	else {
		$('.breed-chooser').css({ 'display':'block', 'padding':'10px 0 0 0', 'border-bottom':'none' })
		$('.breed-chooser select').show()

	   	$('.breed-chooser').parents('.inner').css({ 'padding-left':'0px' })

	  	$('.breed-chooser select').change(function() {
			window.location.href = $(this).val()
		})
  	}

	// -----------------------------------------------
	// HEADER BREED SELECTOR RANDOMIZER
	// -----------------------------------------------

	if ($('#header-breed-selector-images').length > 0) {
		var imgs_a = $('#header-breed-selector-images img')
		var img_a = imgs_a[Math.floor(Math.random() * imgs_a.length)]

		var breed_name = $(img_a).attr('data-breed-name')
		$('#header-breed-selector .breed-chooser select option[data-breed-name="' + breed_name+'"]').prop('selected', true)
		$('#header-breed-selector .breed-chooser select').trigger('chosen:updated')

		setTimeout(function() {
			$(img_a).parents('a').attr('href', $('#header-breed-selector .breed-chooser select').val())
			$(img_a).fadeIn('slow')
		}, 500)
	}


	//
	//
	// PRODUCT CARD CONTAINER
	// -----------------------------------------------

	// $('.product-card-container').click(function(e)
	// {
	// 	if (!$(e.target).is('a') && !$(e.target).parent().is('a'))
	// 	{
	// 		window.location.href = $(this).attr('href');
	// 	}
	// });


	// -----------------------------------------------
	// ADD TO CART BUTTON
	// -----------------------------------------------

	// $('#AddToCart').click(function(e) {
	//   e.preventDefault()

	//   var product_id = $(this).attr('data-item-id')
	//   var quantity = parseInt($('#Quantity').val())
	//   var properties = {}
	//   var $form = $(this).parents('form')

	//   $form.find('[name^="properties"]').each(function (i,v) {
	//     var start = $(this).attr('name').indexOf('[') + 1
	//     var end = $(this).attr('name').indexOf(']')
	//     var n = $(this).attr('name').substring(start, end)
	//     var v = $(this).val()
	//     properties[n] = v
	//   }).get()

	//   addToCart($(this), product_id, quantity, properties)
	// })


	// -----------------------------------------------
	// ADD TO CART MODAL
	// -----------------------------------------------

	function addToCartModal(product_id, quantity, properties) {
		queue(function() {
			return $.post('/cart/add.js', {
				quantity: quantity,
				id: product_id,
				properties: properties
			}, 'json').done(function(variant) {
				queue(function() {
					return $.get('/products/' + variant.handle + '.js', 'json').done(function(product) {
						var URL = buildVariantURL(variant, product)
						var key = variant.key.replace(':','-')
						var $cart_line = $('#cart-modal').find('#cart-item-'+key)

						if ($cart_line.length > 0) {
							var current_qty = parseInt($cart_line.find('.item.qty input').val())
							$cart_line.find('.item.qty input').val(current_qty + quantity)

							var total = variant.price * (current_qty + quantity)

							$cart_line.find('.item.total p').html(Shopify.formatMoney(total))
						} else {
							$('#cart-modal .cart-row-new').removeClass('cart-row-new')
							$('#cart-modal #row-new-product-actions').remove()

							var $product_box = $(_TEMPLATE_MINI_CART_PRODUCT)
							$product_box.addClass('cart-row-new')

							var key = variant.key.replace(':','-')
							$product_box.attr('id', 'cart-item-' + key)
							$product_box.find('.table-product-img').attr('href', URL)
							$product_box.find('.table-product-img img').attr('src',variant.image)

							var title = product.title
							var product_details = false

							if (variant.variant_title != 'Default Title') {
								var variant_details = "<span>" + variant.variant_title

								if (variant.properties) {
									variant_details += "<br/>"

									$.each(variant.properties, function(i,v) {
										variant_details += i + ": " + v + "<br/>"
									})
								}

								variant_details += "</span>"
							}

							if (variant_details) {
								title += variant_details
							}

							$product_box.find('.table-product-title').attr('href', URL).html(title)
							$product_box.find('.item.price p').html(Shopify.formatMoney(variant.price))
							$product_box.find('.item.qty input').val(quantity)

							var total = variant.price * quantity
							$product_box.find('.item.total p').html(Shopify.formatMoney(total))

							$product_box.find('.item.remove a').attr('href', '/cart/change/' + variant.id + '?quantity=0')

							$product_box.insertAfter($('#cart-modal .cart-table .cart-header-row'))

							var $new_product_actions_row = $("<tr class='cart-row-new' id='row-new-product-actions'><td colspan='6'><p>Successfully Added!</p> <a href='/cart' class='btn'>Checkout</a> <a href='' class='btn btn-continue-shopping'>Continue Shopping</a></td></tr>")

							$new_product_actions_row.insertAfter($product_box)

							if ($('#related-cart-sells').length > 0) {
								$('#row-related-items').remove()
								var $related_items_row = $("<tr id='row-related-items'><td colspan='6'></td></tr>")
								$('#related-cart-sells').show().appendTo($related_items_row.find('td'))
								$related_items_row.insertAfter($new_product_actions_row)
								positionFeaturedBlocks()
							}
						}

						updateCartTotals()

						var inst = $('[data-remodal-id=cart-modal]').remodal()
						inst.open()

						setTimeout(function() {
							positionFeaturedBlocks()
						}, 500)

						return
					})
				})
			}).fail(function(msg) {
				// handle failure
			})
		})
		return false
	}

	function buildVariantURL(variant, product) {
		let URL = variant.url

		if (product.tags.length > 0) {
			$.each(product.tags, function(tag) {
				if (tag.indexOf('a:') !== -1) {
					let collection_title = tag.substring(tag.indexOf(':') + 1).trim()
					collection_title = collection_title.replace(' ', '-').toLowerCase()
					URL = '/collections/' + collection_title + variant.url
				}
			})
		}
		return URL
	}

	// -----------------------------------------------
	// CONTINUE SHOPPING BUTTON
	// -----------------------------------------------

	$('#cart-modal').on('click', '.btn-continue-shopping', function(e) {
		e.preventDefault()

		let inst = $('[data-remodal-id=cart-modal]').remodal()
		inst.close()

		return false
	})

	// -----------------------------------------------
	// CLOSE RELATED CART SELLS MODAL
	// -----------------------------------------------

	$('#cart-modal').on('click', '#btn-close-related-cart-sells', function(e) {
		e.preventDefault()

		$('#row-related-items').fadeOut('slow', function() { $(this).remove() })

		return false
	})

	// -----------------------------------------------
	// REMOVE LINE ITEM FROM CART IN MODAL
	// -----------------------------------------------

	$('#cart-modal').on('click', '.remove-item-from-cart', (e) => {
		e.preventDefault()

		//
		//
		// GET INDEX OF CURRENT ROW
		// NOTE THAT line_number FOR SHOPIFY CART IS 1-based INDEX
		// WHEREAS ROW INDEX IS 0-based.
		// BUT THE FIRST TABLE ROW IS THE HEADER, SO ALL IS WELL...
		//
		//
		var $row = $(this).parents('tr.cart-item')
		var index = $('#cart-modal tr').index($row)

		queue(() => {
			return (
				$.post('/cart/change.js',
					{
						quantity: 0,
						line: index
					},
					() => {},
					'json'
				).done(cart => {
					if ($row.hasClass('cart-row-new')) {
							$('.cart-row-new').fadeOut('slow', () => { $(this).remove() })
					} else {
						$row.fadeOut('slow', () => { $(this).remove() })
					}

					updateCartTotals()
				})
			)
		})

		return false
	})

	$('.cart-table .remove a').on('click', function(e) {
		e.preventDefault();
		
		const href = $(this).attr('href');
		const lineIndex = parseInt(href.match(/line=(\d+)/)[1]);
		const $currentItem = $(this).closest('.cart-item');
		
		removeCartLineItem(lineIndex);

		$currentItem.fadeOut(300, function() {			
			updateCartTotals(() => {
				window.location.reload()
			});
		});	
	});
		
	//-----------------------------------------------
	// UPDATE CART
	// -----------------------------------------------

	$('#cart-modal').on('click', '#btn-update-cart', function(e) {
		e.preventDefault()

		let updates = new Array()

		$('#cart-modal .cart-table input.quantity').each(function() {
			updates.push($(this).val())
		})

		queue(function() {
			return $.post('/cart/update.js',
			{
				updates: updates
			},
			'json'
			).done(function(cart) {
				$.each(updates, function(i, v) {
					if (v == 0) {
						$('#cart-modal .cart-table tr').eq(i + 1).remove()
					}
				})

				$.each(cart.items, function(i,item) {
					$('#cart-modal .cart-table .item.total').eq(i + 1).find('p').html(Shopify.formatMoney(item.line_price))
				})

				updateCartTotals()
			}).fail(function() {
				alert('The quantity that you entered is not available. Please select a lower quantity to continue')
			})
		})
		return false
	})

	// -----------------------------------------------
	// PRODUCT IMAGES
	// -----------------------------------------------

	$('.product-single__thumbnail').click(function(e) {
		e.preventDefault()

		$('#product-image-main').trigger('zoom.destroy')

		let img_src = $(this).find('.product-img-large').attr('src')
		let img_src_zoom = $(this).attr('data-zoom')

		if (img_src) {
			$('#ProductPhotoImg').attr('src',img_src)
			$('#product-image-main').attr('data-zoom', img_src_zoom)
		}

		return false
	})

	$('#product-image-zoom-toggle, #product-image-main').click(function(e) {
		e.preventDefault()

		if (Modernizr.mq('(max-width: 1024px)')) {
			if ($(e.currentTarget).attr('id') == 'product-image-main') {
			return false
			}
		}

		let $productImageMain = $('#product-image-main')

		if ($(this).hasClass('zoom-enabled')) {
			$productImageMain.trigger('zoom.destroy')
			$(this).removeClass('zoom-enabled')
		} else {
			$(this).addClass('zoom-enabled')

			var productImgSrc = $productImageMain.attr('data-zoom')

			$productImageMain.zoom({
			url: productImgSrc,
			callback: function() {
				$container = $productImageMain
				$zoomedImage = $(this)

				let offsetWidth = ($container.outerWidth() - $zoomedImage.outerWidth()) / 2
				let offsetHeight = ($container.outerHeight() - $zoomedImage.outerHeight()) / 2

				$(this).css({
				top: Math.round(offsetHeight * 100) / 100,
				left: Math.round(offsetWidth * 100) / 100
				})
			}
			})
		}

		return false
	})

	// -----------------------------------------------
	// CUSTOMER ACCOUNTS
	// -----------------------------------------------

	$('#btn-forgot-password').click(function(e) {
		e.preventDefault()

		$('#form-container-login').hide()
		$('#form-container-reset-password').show()

		return false
	})

	$('#btn-cancel-reset-password').click(function(e) {
		e.preventDefault()

		$('#form-container-reset-password').hide()
		$('#form-container-login').show()

		return false
	})

	if (window.location.hash == '#recover') {
		$('#form-container-login').hide()
		$('#form-container-reset-password').show()
	}

	// -----------------------------------------------
	// ALERT MAX QUANTITY ON CART PAGE
	// -----------------------------------------------

	$('[max]').change(function() {
		var max = parseInt(jQuery(this).attr('max'), 10) || 10000
		var value = parseInt(jQuery(this).val(), 10) || 0
		if (value > max) {
			alert('We only have ' + max + ' of this item in stock')
			$(this).val(max)
		}
	})

	// -----------------------------------------------
	// VIEW TOGGLE
	// -----------------------------------------------

	$('#view-toggle a').click(function(e) {
		e.preventDefault()

		$('#view-toggle a').removeClass('active')
		$(this).addClass('active')

		if ($(this).attr('data-view') == 'grid') {
			$('.collection-grid').removeClass('section-product-boxes-list')
			Cookies.set('collection-view', 'grid')
		} else if ($(this).attr('data-view') == 'list') {
			$('.collection-grid').addClass('section-product-boxes-list')
			Cookies.set('collection-view', 'list')
		}

		return false
	})

	// --------------------------------
	// CART PAGE - INCREMENT QUANTITY
	// --------------------------------

	$('.cart-table input.quantity').on('change', function() {
		const $target = $(this)
		const lineItemKey = $target.context.dataset.key
		const lineItemQuantity = $target.context.value

		if (lineItemQuantity < 1) {
			alert('Please enter an larger quantity or remove the item from cart')
			return
		}

		updateCartLineItem(lineItemKey, lineItemQuantity)
	})

	// --------------------------------
	// Updates variant in cart
	// --------------------------------

	$('.cart-table div.properties').on('change', (e) => {
		const $target = $(e.target) // the select element
		const lineItemKey = $target.attr('data-key').replace(':', '-') // line item key from the select's data attribute
		const $currentItem = $('#cart-item-' + lineItemKey) // the current item in the cart
		const $options = $currentItem.find('.cart-select-option option:selected') // options for the current item
		const variants = $currentItem.data('variants') // variants for the current item -- variants type is Object
		const removeIndex = $currentItem.data('index') // index of the current item
		const lineItemQuantity = $currentItem.find('.input-quantity').val() // quantity of the current item
		const $properties = $currentItem.find('.property') // current properties for the current item
		let variant = '' // string to hold the variant

		// Check if there are an option:selected
		if ($options.length > 0) {
			// Loop through each option and add its value to the variant string
			$options.each(i => {
				variant += $options[i].value.replace(/"/g, "in");

				if (i < $options.length - 1) {
					variant += "/"
				}
			})
		} else {
			for (const key in variants) {
				if (variants.hasOwnProperty(key)) {
					variant += key
				}
			}
		}

		let properties = {}
		$properties.each(i => {
			// get the name of the property
			const propertyName = $properties[i].name
			// get the value of the property
			const propertyValue = $properties[i].value
			// add the property to the properties object
			properties[propertyName] = propertyValue
		})

		if ($target.context.tagName === "INPUT") {
			properties[$target.context.name] = $target.context.value
		}

		if ($target.context.value === "No") {
			for (const key in properties) {
				if (key.includes("Dog Name")) {
					properties[key] = "";
				}
				if (key.includes("Dog Name (15 character max)")) {
					properties[key] = "";
				}
			}
		}


		// Get the variant ID for the selected variant
		let variantID = variants[variant]?.id ?? null;

		// If the variant ID is undefined, the variant is unavailable, so alert the user and reset the select to the previously selected option
		if (variantID === undefined) {
			alert('Variant "' + variant + '" is unavailable at this time')
			// Loop through each option and set the select to the previously selected option
			$options.each(i => {
				$options[i].selected = $options[i].defaultSelected
			})
			return
		}

		// Update select width
		initCartSelectWidth($target)

		// If the variant ID and quantity are valid, remove the current item from the cart and add it back with the new variant ID and quantity
		if (properties && variantID && lineItemQuantity) {
			removeCartLineItem(removeIndex)
			updateCartLineItemVariant(variantID, lineItemQuantity, properties)
		}
	})

	// --------------------------------
	// CONDITIONALLY sets requred arrtibure on fields
	// --------------------------------

	function handleChangeVariant(event) {
		let selectedVariant;
		if (event) {
			event.preventDefault();

			// Get selected option's value (normalized)
			selectedVariant = event.target.value.toLowerCase().trim();
		}else{
			const selectedVariantElement = document.querySelector('.product__main__variant-picker select');
			if (!selectedVariantElement) {
				return;
			}
        	selectedVariant = selectedVariantElement.value.toLowerCase().trim();
		}

		// Find the target fields
		const engravingFields = document.querySelectorAll(".product-form__input.product-form__input--has-instructions");

		if (engravingFields.length === 0) {
			return;
		}

		engravingFields.forEach(engravingField => {
			if (selectedVariant.includes("engraving")) {
				engravingField.setAttribute("required", "required");
			} else {
				engravingField.removeAttribute("required");
			}
		})
	}

	const variantPicker = document.getElementsByClassName('product__main__variant-picker')[0];

	if(variantPicker) {
		variantPicker.querySelectorAll("select").forEach(select => {
			select.addEventListener("change", handleChangeVariant);
		});

		handleChangeVariant();
	}

	// --------------------------------
	// CART PAGE - Change Items Options Value
	// --------------------------------

	const initCartSelectWidth = (select) => {
		// Create a temporary element to measure the width of the selected option's text
		let $temp = $('<span>').html(select.find('option:selected').text()).appendTo('body')
		let width = $temp.width()
		$temp.remove()

		// Apply a buffer to ensure the text isn't cut off
		const calculateBuffer = (width) => {
			if (width == 0) return 200
			if (width < 26) return 10
			if (width > 150) return 80
			if (width < 50) return 20
			return 30 + 0.5 * (width - 50)
		}
		width += calculateBuffer(width)

		// Set the width of the select element
		select.width(width)
	}

	// Loop through each select element in the cart table
	$('.cart-table select.cart-select').each((index, option) => {
		// Get a jQuery object of the current select element
		let $option = $(option)
		// Run the function to set the width of the select element
		initCartSelectWidth($option)
	})

	// If you want to update the width whenever an option is selected, you can add this event listener
	$('.cart-table select.cart-select').change((event) => {
		initCartSelectWidth($(event.target))
	})


	// -----------------------------------------------
	// DISCOUNTED PRODUCTS REQUIRE PAGE RELOAD ON QUANTITY UPDATE
	// -----------------------------------------------

  	$('.cart-table input.quantity-discount').on('change', function(e) {
      	var $cell = $(this).parents('td')

		if ($cell.find('.btn-update-quantity').length < 1) {
			$cell.append("<button type='submit' class='btn btn-primary btn-update-quantity' style='padding: 5px 10px;font-size:.8em;letter-spacing:.05em;'>Update</button>")
		}
    })

	// --------------------------------
	// CART HOVER MODAL FUNCTIONALITY
	// --------------------------------

	// Elements
	const cartIcon = document.querySelector('.logo-bar__links #cart-icon');
	const cartWrapper = document.querySelector('.cart-message-wrapper');
	const cartExitButton = document.querySelector('.cart-message__close');

	if (cartIcon) {
		// Holds the ID returned by setTimeout to be cleared later once the user stops hovering 
		let hoverCheckTimeout = null;

		// Hide cart modal when no longer hovering over icon or modal after checking hover state 
		function checkHoverState() {
			clearTimeout(hoverCheckTimeout);
			hoverCheckTimeout = setTimeout(() => {
				const stillHovering = cartIcon.matches(':hover') || cartWrapper?.matches(':hover');
				if (!stillHovering) {
					hideCartModal();
				}
			}, 250);
		}

		// Show modal on hover
		cartIcon.addEventListener('mouseenter', showCartHoverPreview);

		// Check when user leaves hover over cart icon
		cartIcon.addEventListener('mouseleave', checkHoverState);

		// Check when user leaves hover over cart message
		cartWrapper?.addEventListener('mouseleave', checkHoverState);

		// Allow manual close with "X" button
		cartExitButton?.addEventListener('click', hideCartModal);
	}

	/*
	Cookies.set('name', 'value')
	Cookies.get('name')
	Cookies.get() // => { name: 'value' }
	Cookies.remove('name')
	Cookies.set('name', { foo: 'bar' })
	Cookies.getJSON('name') // => { foo: 'bar' }
	*/
	if (Cookies.get('collection-view') == 'list') {
		$('#view-toggle a[data-view=list]').click()
	}

	// -----------------------------------------------
	// RECENTLY VIEWED
	// -----------------------------------------------

	var recently_viewed_max = 4;
	var recently_viewed = Cookies.getJSON? Cookies.getJSON('recently-viewed') : [];

	//console.log('RECENTLY VIEWED');
	//console.log(recently_viewed);

	// loadRecentlyViewed();
	addToRecentlyViewed()

	// Not called any where
	// const loadRecentlyViewed = function (callback) {
	// 	if ($('.recently-viewed-container').length > 0 && recently_viewed && recently_viewed.length > 0) {
	// 		// $('.section-recently-viewed').show();
	// 		// $('.section-recently-viewed .section-header').show();

	// 		$.each(recently_viewed, function(i,url) {
	// 			$('#featured-block-recently-viewed').append("<li class='product-box product-box-loading product-card'></li>");
	// 			$($('.recently-viewed-container .product-box')[i]).show();

	// 			$.get(url, function(html) {
	// 				var product_box = $(html).find('#product-box-template').html();
	// 				var $product_box_contents = $(product_box).html();

	// 				var $pb = $($('.recently-viewed-container .product-box')[i]);
	// 				$pb.html($product_box_contents);
	// 				$pb.removeClass('product-box-loading');

	// 				if (callback) callback($pb.get()[0])
	// 			}).done(function(e) {
	// 				positionFeaturedBlocks();

	// 				setTimeout(function() {
	// 					positionFeaturedBlocks();
	// 				}, 500);
	// 			}).fail(function(msg) {
	// 			});
	// 		});
	// 	}
	// }

	function addToRecentlyViewed() {
		let product_page_url = window.location.href.match(/.*\/products\/.*/g)

		if (product_page_url && product_page_url[0]) {
			let the_url = product_page_url[0].split(/[?#]/)[0]

			if (recently_viewed) {
				var urls = recently_viewed
			} else {
				var urls = Array()
			}

			if ($.inArray(the_url, urls) == -1) {
				if (urls.length >= recently_viewed_max) {
					urls.shift()
				}
				urls.push(the_url)
			}
			Cookies.set('recently-viewed', urls)
		}
	}
})

